<template>
    <section class="viewSection">
        <!-- <div class="line"></div> -->
        <div class="formItem"
           @click="choosePicker(item, listIndex, index)"
           v-for="(item,index) in dataList"
           :key="index">
            <span class="formLabel">{{ item.label }}</span>
            <span class="rightText"
                  :class="{'selected': item.value.dataDictValue }">
                {{ item.value ? item.value.dataDictValue : required?'请选择':'选填' }}
            </span>
            <i class="iconfont icon-jiantou right"></i>
        </div>
    </section>
</template>

<script>
export default {
    name: 'accurate',
    props: {
        chooseCondition: {
            type: Function
        },
        dataList: {
            type: Array,
            default: []
        },
        required: {
            type: Boolean,
            default: true
        },
        listIndex: {
            type: Number,
            default: 0
        },
        licenseDate: {
            type: String,
        }
    },
    methods: {
        choosePicker(item, listIndex, index) {
            this.chooseCondition(item, listIndex, index)
        }
    }
}
</script>

<style scoped>
.formLabel {
    display: inline-block;
    flex-shrink: 0;
    width: 0.85rem;
    /* margin-right: 0.16rem; */
    font-size: 0.16rem;
    font-weight: normal;
    color: #000;
}

.viewSection {
    /*margin-top: 0.2rem;*/
    /*border-top: #5e5e66 solid 1px;*/
}

.line {
    height: 0.1rem;
    background-color: #F7F8FA;
}

.rightText {
    height: 0.53rem;
    line-height: 0.53rem;
    font-size: 0.16rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    right: 0.2rem;
    text-align: right;
    color: #B0B1B8;
}

.selected {
    color: #1a1a1a;
}

.line{
    background-color: #F7F8FA;
    height: 0.08rem;
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/searchForm/components/accurateFormItem.vue